import React, { Component } from 'react';
import { Button, Typography } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import baseStyle from '../../../../styles/wizardBase';
import { FormattedMessage } from 'react-intl';

class StaffWizardPage5 extends Component {
  constructor(props){
    super(props);
    this.state = {
      checked: false
    }
  }

  close = () => {
    this.props.close();
  };

  render()  {
    const { classes } = this.props;
    return (
      <Dialog
        disableEscapeKeyDown
        fullWidth={true}
        open={this.props.open}
        onClose={this.props.close}
        aria-labelledby="form-dialog-title"
        PaperProps={{ classes:{ root: classes.container }}}
      >
        <DialogTitle disableTypography={true} className={ classes.title } id="form-dialog-title">
          <Typography className={ classes.titleText } variant='h4'><FormattedMessage id='Wizard.Staff.title'/></Typography>
          <IconButton
            onClick={this.close}
            className={ classes.exitIcon }
            aria-label="close dialog"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <DialogContentText>
            This user has been added to your organization!
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttons}>
          <Button onClick={this.close} color="primary">
            <FormattedMessage id='General.ok'/>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(baseStyle)(StaffWizardPage5);